
// import './App.css';
import { useEffect, useState } from 'react';
import App_Wrapper from './App_Wrapper';


function App() {
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("DR_Mode"))?.Mode == "Dark") {
      document.getElementById("body").setAttribute("Theme", "Dark");
    } else {
      document.getElementById("body").setAttribute("Theme", "Light");
    }
  })

  const [Resetter_Key, Resetter_Key_Set] = useState(Date.now());

  window.App_Reset = () => {
    Resetter_Key_Set(Date.now());
  }
  return (
    <App_Wrapper key={Resetter_Key}/>
    

  );
}

export default App;
